<template>
  <el-table-column
    prop="expiration_date"
    label="Szav. idő"
    min-width="200"
  >
    <template slot-scope="scope">
      {{ scope.row.expiration_date }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'supplier.name',
  };
</script>
